import Utils from "../utils/utils"

export class Colors {
    public isEnabled: boolean = false
    public colorBkgd: string = ""
    public colorDetail: string = ""
    public colorLine: string = ""
    public colorSelectedBkgd: string = ""
    public colorSelectedText: string = ""
    public colorSub: string = ""
    public colorSubTrim: string = ""
    public colorText: string = ""

    constructor(colors) {
        Object.keys(colors).map((key) => {
            const property = Utils.convertToCamelcase(key)
            this[property] = colors[key]
        })
    }
}
